import { LookupType } from '../models'
export const LookupTypes: LookupType[] = [
  {
    ClassificationLookUp: 1,
    GroupLookUp: 2,
    TypeLookUp: 3,
    Category1LookUp: 4,
    Category2LookUp: 5,
    StatusLookUp: 6,
    ParticipationTypeLookUp: 7,
    OrganizationLookUp: 8,
    CommitteeLookUp: 9,
    MeetingLookUp: 10,
    TeamLookUp: 11,
    ConfidentialityLookUp: 12,
    AuthenticationToolLookUp: 12
  }
]